import { useCallback, useState } from 'react';
import { DEFAULT_SORT, isValidSort } from './projectListModel';

// Per-browser memory of the projects page's view (table/cards) and sort
// (STRY0038867). Storage can be unavailable (private mode, blocked site data),
// so every access is guarded and falls back to the defaults.
const STORAGE_KEY = 'bz.plan.projectsList.v1';
const VIEWS = ['list', 'grid'];
const DEFAULTS = { view: 'list', sort: DEFAULT_SORT };

function readPrefs() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const stored = raw ? JSON.parse(raw) : {};
    return {
      view: VIEWS.includes(stored.view) ? stored.view : DEFAULTS.view,
      sort: isValidSort(stored.sort) ? { key: stored.sort.key, dir: stored.sort.dir } : DEFAULTS.sort
    };
  } catch (e) {
    return DEFAULTS;
  }
}

function writePrefs(prefs) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
  } catch (e) {
    // A convenience only — the page works without it.
  }
}

export default function useProjectListPrefs() {
  const [prefs, setPrefs] = useState(readPrefs);

  const update = useCallback(patch => {
    setPrefs(current => {
      const next = { ...current, ...patch };
      writePrefs(next);
      return next;
    });
  }, []);

  const setView = useCallback(view => update({ view: VIEWS.includes(view) ? view : DEFAULTS.view }), [update]);
  const setSort = useCallback(sort => update({ sort: isValidSort(sort) ? sort : DEFAULTS.sort }), [update]);

  return { view: prefs.view, sort: prefs.sort, setView, setSort };
}
